<p-carousel
  [value]="mediaContainers()"
  [numVisible]="1"
  [numScroll]="1"
  [circular]="true"
  [autoplayInterval]="autoplayInterval()"
  [showIndicators]="showIndicators()"
  [classList]="'custom-carousel floating-indicator'"
>
  <ng-template pTemplate="container" let-container>
    @if (container.link) {
      <cx-link [link]="container.link">
        <cx-media [media]="container.medias" />
      </cx-link>
    } @else {
      <cx-media [media]="container.medias" />
    }
  </ng-template>

  <ng-template pTemplate="previousicon">
    <span class="material-symbols-outlined text-primary pe-2">arrow_back_ios_new</span>
  </ng-template>

  <ng-template pTemplate="nexticon">
    <span class="material-symbols-outlined text-primary ps-2">arrow_forward_ios</span>
  </ng-template>
</p-carousel>
